module.exports = __webpack_public_path__ + "static/mapaOJPIII-2efcd548b88bf1df82e0407aaf238a58.png";